import { useRef, useState, useEffect } from 'react';

export const useOnceLoader = ({
  skip,
  isError,
  isFetching,
  resetTrigger,
  isUninitialized,
}: {
  skip?: boolean;
  isError: boolean;
  resetTrigger?: any;
  isFetching: boolean;
  isUninitialized: boolean;
}) => {
  const lastResultIsError = useRef(false);
  const [isLoadingState, setLoading] = useState(
    isFetching || (isUninitialized && !skip)
  );

  const isLoading = (isFetching && lastResultIsError.current) || isLoadingState;

  useEffect(() => {
    if (resetTrigger && !skip) {
      return () => setLoading(true);
    }
  }, [resetTrigger, skip]);

  useEffect(() => {
    if (isUninitialized) {
      return;
    }

    if (isLoadingState && !isFetching) {
      setLoading(false);
      lastResultIsError.current = isError;
    } else if (isFetching && !isLoadingState && lastResultIsError.current) {
      lastResultIsError.current = false;
      setLoading(true);
    }
  }, [isFetching, isError, isLoadingState, isUninitialized]);

  return { isLoading, setLoading };
};
